import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=65dfd186&scoped=true"
import script from "./ErrorLabel.vue?vue&type=script&lang=js"
export * from "./ErrorLabel.vue?vue&type=script&lang=js"
import style0 from "./ErrorLabel.vue?vue&type=style&index=0&id=65dfd186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfd186",
  null
  
)

export default component.exports